import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { forgotPassword, getLoggedInUser } from '../axios';
import toast from 'react-hot-toast';
import { motion } from "framer-motion";
import * as imagesdata from '../imagesdata'
const ForgotPassword = () => {
    const [user, setUser] = useState(null);
    const [formData, setFormData] = useState({
        email: ''
    });

    const [emailContinue, setEmailContinue] = useState(false);
    const [windowHeight, setWindowHeight] = useState(0);
    const [windowWidth, setWindowWidth] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [timeLeft, setTimeLeft] = useState(0);

    const [isButtonDisable, setIsButtobDisable] = useState(false);

    function setEmailHandler(evt) {
        setFormData({ ...formData, email: evt.target.value });
    }

    const doSendMail = (e) => {
        e.preventDefault();
        setIsButtobDisable(true)
        forgotPassword(formData.email)
            .then((res) => {
                toast.success(res.data)
                setEmailContinue(true)
                setTimeLeft(180);
                setIsButtobDisable(false)
            })
            .catch((err) => {
                toast.error(err.response.data)
                setIsButtobDisable(false)
            })
    }

    const animations = {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
    };

    useEffect(() => {
        let timer;
        if (timeLeft > 0) {
            timer = setInterval(() => {
                setTimeLeft((prevTime) => prevTime - 1);
            }, 1000);
        } else {
            clearInterval(timer);
        }

        return () => clearInterval(timer);
    }, [timeLeft]);

    const formatTime = (seconds) => {
        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = seconds % 60;
        return `${minutes}:${remainingSeconds.toString().padStart(2, "0")}`;
    };

    useEffect(() => {
        const handleResize = () => {
            const height = window.innerHeight;
            const width = window.innerWidth;
            if (window.innerHeight < 620) {
                setWindowHeight(620)
            }
            else {
                setWindowHeight(height)
            }
            setWindowWidth(width)
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const togglePW = () => {
        setShowPassword(!showPassword);
    };

    useEffect(() => {
        const checkAuth = async () => {
            try {
                const response = await getLoggedInUser();
                setUser(response.data)

            } catch (error) {
                setUser(null)
            }
        };
        checkAuth();
    }, []);


    if (user) {
        return window.location.href = '/';
    } else {
        return (
            <motion.div
                className="py-3"
                variants={animations}
                initial="initial"
                animate="animate"
                exit="exit"
                transition={{ duration: 1 }}
            >
                <div className="wrapper" style={{ backgroundColor: "white", maxHeight: windowHeight - 1 }}>
                    <form onSubmit={doSendMail} className='auth-form'>
                        <div className="login-options">
                            <div className="login-image-container" style={{
                                height: windowHeight < windowWidth - 500 ? windowWidth - 500 : windowHeight - 1,
                                width: windowWidth,
                                overflowY: 'hidden'
                            }}>
                                <img className="login-image" src={imagesdata.Auth} alt="Login" />
                            </div>
                            {
                                emailContinue == true ?
                                    (
                                        <div className="login-form" style={{ height: windowHeight }}>
                                            <div onClick={(e) => window.location.href = '/giris-yap'} className='login-back'>
                                                <svg class="login-back-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15 19-7-7 7-7" />
                                                </svg>
                                                <span>
                                                    Geri Dön
                                                </span>
                                            </div>
                                            <a href='/'><img src={imagesdata.TersLogo} alt="Logo" style={{ height: "69px", width: "200px", marginTop: "50px" }} /></a>
                                            <h2 style={{ marginBottom: "0", paddingBottom: "10px" }}><span>Şifre Gönderildi</span></h2>
                                            <div className='login-form-desc'><span>{formData.email}</span> adresine şifre yenileme linkiniz gönderildi.</div>
                                            <div className='login-form-desc-list'>
                                                <ul>
                                                    Şifre Yenileme e-postası elinize ulaşmadıysa:
                                                    <li style={{ marginTop: "10px" }}>Şifre yenileme e-postasının gelmesi 10 dakikayı bulabilir.</li>
                                                    <li style={{ }}>Spam ve diğer e-posta klasörlerinizi kontrol ediniz.</li>
                                                    <li style={{ }}>Girdiğiniz e-posta adresinin doğruluğunu kontrol ediniz.</li>
                                                </ul>
                                            </div>
                                            <div style={{ width: "100%" }}>
                                                <button className="auth-button button-submit" type="submit" disabled={timeLeft > 0}> <span> Tekrar Gönder {timeLeft > 0 ? `(${formatTime(timeLeft)})` : ""} </span></button>
                                            </div>
                                        </div>
                                    ) :
                                    (
                                        <div className="login-form" style={{ height: windowHeight }}>
                                            <div onClick={(e) => window.location.href = '/giris-yap'} className='login-back'>
                                                <svg class="login-back-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                                                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m15 19-7-7 7-7" />
                                                </svg>
                                                <span>
                                                    Geri Dön
                                                </span>
                                            </div>
                                            <a href='/'><img src={imagesdata.TersLogo} alt="Logo" style={{ height: "69px", width: "200px", marginTop: "50px" }} /></a>
                                            <h2 style={{ marginBottom: "0", paddingBottom: "10px" }}><span>Şifremi Yenileme</span></h2>
                                            <div className='login-form-desc'>Şifre yenileme bağlantısını gönderebilmemiz için e-posta adresinize ihtiyacımız var.</div>
                                            <div className="form-wrapper" >
                                                <label htmlFor="email">E-posta</label>
                                                <input
                                                    type="email"
                                                    className="form-control"
                                                    name="email"
                                                    value={formData.email}
                                                    onChange={setEmailHandler}
                                                />
                                            </div>
                                            <div style={{ width: "100%" }}>
                                                <button className="auth-button button-submit" disabled={isButtonDisable} type="submit"> <span> Mail Gönder </span></button>
                                            </div>
                                        </div>
                                    )
                            }

                        </div>
                    </form>
                </div>
            </motion.div>
        );
    }
}

export default ForgotPassword